import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { MobileWizards } from '../MobileWizards'
import { useRootStore } from 'stores/RootStore'
import { WizardProps } from '../Types'
import { WizardType } from 'components/Wizards/schemas/Types'
import { useRef } from 'react'
import { useIsScrolled } from 'hooks/useIsScrolled'

interface MobileWizardsDrawerProps extends DrawerProps, Pick<WizardProps, 'initialValues'> {
  channel: WizardType
}

export const MobileWizardsDrawer = observer((props: MobileWizardsDrawerProps) => {
  const { channel, initialValues, ...rest } = props
  const { closeDrawer } = useRootStore().drawersStore
  const bodyRef = useRef<HTMLDivElement>(null)
  const isScrolled = useIsScrolled(bodyRef.current)

  return (
    <Drawer.Root {...rest}>
      <Drawer.Portal>
        <Drawer.Content fullHeight disableAnimation>
          <div style={{ height: '100%' }} data-vaul-no-drag>
            <Drawer.InnerContent isSnappedTop>
              <Drawer.Container padding="0px" ref={bodyRef}>
                <MobileWizards
                  channel={channel}
                  onClose={closeDrawer}
                  initialValues={initialValues}
                  isScrolled={isScrolled}
                />
              </Drawer.Container>
            </Drawer.InnerContent>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
})
